import logger from "loglevel";
var env = process.env.APP_ENV || "production" || "development";
var level = env !== "production" ? "debug" : "info";
logger.setLevel(level);
export default logger;